import { useId } from "react";
import { DefaultMap as a } from "../utils/default-map.js";
import { createStore as a$1 } from "../utils/store.js";
import { useIsoMorphicEffect as n } from "./use-iso-morphic-effect.js";
import { useStore as o } from "./use-store.js";
let p = new a(() => a$1(() => [], { ADD(r) {
  return this.includes(r) ? this : [...this, r];
}, REMOVE(r) {
  let e = this.indexOf(r);
  if (e === -1) return this;
  let t = this.slice();
  return t.splice(e, 1), t;
} }));
function x(r, e) {
  let t = p.get(e), i = useId(), h = o(t);
  if (n(() => {
    if (r) return t.dispatch("ADD", i), () => t.dispatch("REMOVE", i);
  }, [t, r]), !r) return false;
  let s = h.indexOf(i), o$1 = h.length;
  return s === -1 && (s = o$1, o$1 += 1), s === o$1 - 1;
}
export {
  x as useIsTopLayer
};
